module.exports = "/packs/images/svg/info~3739567779adf196882d36f6b8507209.svg";